import request from '@/api/request'

export default {
  getProfile () {
    const url = `/profile/get`
    return request({ method: 'GET', url, headers: { 'Cache-Control': 'no-cache' } })
  },
  savePersonalInformation (payload) {
    const url = '/profile/change'
    return request({ method: 'POST', url, data: payload })
  },
  saveChangePassword (payload) {
    const url = '/profile/change-password'
    return request({ method: 'POST', url, data: payload })
  }
}
